import { render, staticRenderFns } from "./EdgeboardTasktypeConfigModal.Style#Drawer.vue?vue&type=template&id=518c297b&scoped=true&"
import script from "./EdgeboardTasktypeConfigModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./EdgeboardTasktypeConfigModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./EdgeboardTasktypeConfigModal.Style#Drawer.vue?vue&type=style&index=0&id=518c297b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518c297b",
  null
  
)

export default component.exports